import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  getUsers() {
    return axiosIns.get('/v2/employee/wage_management/users')
  },
}
